export const youTubeSubscribeButtonMetaData = {
    isRepeatable: false
}
